import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var carouselBehavior = function carouselBehavior() {
  Alpine.data('carouselBehavior', function () {
    return {
      carousel: undefined,
      init: function init() {
        this.initSlider();
      },
      initSlider: function initSlider() {
        if (this.carousel === undefined) {
          this.carousel = new Splide(this.$el, {
            perPage: 1,
            arrowPath: 'M30.429 16.2081L17.019 3.91558L20.5545 0.674683L40 18.4998L20.5545 36.3246L17.019 33.0837L30.429 20.7914H0V16.2081H30.429Z',
            gap: '2em',
            padding: '3em',
            omitEnd: true,
            breakpoints: {
              639: {
                padding: '0'
              }
            }
          });
          this.carousel.on('pagination:mounted', function (data) {
            // You can add your class to the UL element
            data.list.classList.add('splide__pagination--custom');

            // `items` contains all dot items
            data.items.forEach(function (item) {
              item.button.textContent = String(item.page + 1);
            });
          });
          this.carousel.mount();
        }
      }
    };
  });
};